import { render, staticRenderFns } from "./EntitySimpleNotes.vue?vue&type=template&id=c6a81fc8&"
import script from "./EntitySimpleNotes.vue?vue&type=script&setup=true&lang=js&"
export * from "./EntitySimpleNotes.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports